import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { takeWhile } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/application-store';
import * as userSettingsSelectors from '../../../user-settings/selectors/user-settings';
import { ApplicationModeService } from '../../../application-mode/services/application-mode.service';
import {MciPreviewModeDialogContainerComponent} from "@feature/preview-mode";

@Component({
  selector: 'mojo-mci-preview-mode-tile-widget',
  templateUrl: './mci-preview-mode-tile.html'
})
export class MciPreviewModeTileComponent implements OnInit, OnDestroy {

  @ViewChild('mciPreviewer', { static: true })
  mciPreviewer: MciPreviewModeDialogContainerComponent;

  isAlive = true;
  inPreviewMode: boolean;
  showDialog = false;
  isInDashboardMode: boolean;

  constructor(
    private readonly appModeService: ApplicationModeService,
    private readonly store: Store<ApplicationState>) {

    this.appModeService.isInMyDashboardMode().subscribe(m => this.isInDashboardMode = m);

    this.store
      .pipe(
        select(userSettingsSelectors.getUserSettings),
        takeWhile(() => this.isAlive)
      ).subscribe(settings => {
        this.inPreviewMode = settings.IsInPreviewMode;
      });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  tileClick(): void {
    if (!this.inPreviewMode) {
      this.mciPreviewer.doShowDialog();
    }
  }
}
